import { z } from "zod";

import { DEFAULT_RATE_LIMIT_SETTINGS, RateLimitSettingsSchema } from "../RateLimit.schema";

export const ExcelDeploymentSettingsSchema = z.object({
  skillNames: z.array(z.string()).default([]),
  functionName: z.string().default("NEXUS"),
  rateLimitSettings: RateLimitSettingsSchema.optional()
});

export type ExcelDeploymentSettings = z.infer<typeof ExcelDeploymentSettingsSchema>;

export const DEFAULT_EXCEL_SETTINGS: ExcelDeploymentSettings = {
  skillNames: [],
  functionName: "NEXUS",
  rateLimitSettings: DEFAULT_RATE_LIMIT_SETTINGS
};

/** Create Excel Add-in deployment settings with defaults. Accepts unknown (raw Prisma JsonValue). */
export function createExcelDeploymentSettings(overrides?: unknown): ExcelDeploymentSettings {
  if (!overrides || typeof overrides !== "object" || Array.isArray(overrides)) {
    return { ...DEFAULT_EXCEL_SETTINGS };
  }
  return { ...DEFAULT_EXCEL_SETTINGS, ...overrides } as ExcelDeploymentSettings;
}
